import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWithdrawal2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #fff;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M400,212.42c15.59,0,28.26,12.68,28.26,28.27,0,11.57,9.42,20.99,21,20.99s20.99-9.42,20.99-21.01c-.1-30.74-20.18-57.73-49.26-66.82v-15.27c0-11.57-9.42-20.99-20.99-20.99s-21,9.42-21,20.99v15.32c-28.36,9.26-48.11,35.88-48.47,65.95-.22,18.77,6.87,36.49,19.98,49.92,13.11,13.42,30.66,20.95,49.49,21.17,15.59,0,28.26,12.68,28.26,28.27s-12.67,28.26-28.26,28.26-28.27-12.67-28.27-28.26c0-11.58-9.42-21-20.99-21s-21,9.42-21,21.02c.1,30.74,20.18,57.72,49.26,66.82v15.27c0,11.57,9.42,20.99,21,20.99s20.99-9.42,20.99-20.99v-15.31c28.36-9.26,48.11-35.89,48.47-65.96.22-18.76-6.87-36.49-19.98-49.92-13.1-13.42-30.66-20.95-49.48-21.17-15.59,0-28.27-12.67-28.27-28.26s12.68-28.27,28.27-28.27h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M709.71,50.83H90.29c-32.34,0-58.64,26.31-58.64,58.64v360.96c0,32.34,26.31,58.64,58.64,58.64h619.42c32.34,0,58.64-26.31,58.64-58.64V109.47c0-32.34-26.31-58.64-58.64-58.64h0ZM76.74,109.47c0-7.47,6.08-13.55,13.55-13.55h619.42c7.47,0,13.55,6.08,13.55,13.55v360.96c0,7.47-6.08,13.55-13.55,13.55H90.29c-7.47,0-13.55-6.08-13.55-13.55V109.47Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M157.08,318.15c7.13,7.13,16.57,11.05,26.58,11.05s20.29-4.23,27.58-11.58c15.06-15.06,14.82-39.81-.53-55.16-7.3-7.3-17.01-11.32-27.34-11.32h-.05c-10.32,0-19.99,4.03-27.25,11.33-.16.16-.31.33-.44.51-7.03,7.26-10.88,16.8-10.87,26.93,0,10.32,4.04,19.99,11.32,27.24l1,1h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M590.24,318.15c7.13,7.13,16.57,11.05,26.58,11.05s20.29-4.23,27.58-11.58c15.06-15.06,14.82-39.81-.53-55.16-7.3-7.3-17.01-11.32-27.34-11.32h-.05c-10.32,0-20,4.04-27.25,11.33-.16.16-.31.33-.44.51-7.03,7.26-10.88,16.8-10.87,26.93.01,10.32,4.04,19.99,11.32,27.24l1,1h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M512.64,547.96c-.32-.06-.65-.09-.98-.09-12.26,0-22.24,9.98-22.24,22.24v116.24c0,12.26,9.98,22.24,22.24,22.24s22.24-9.98,22.24-22.24v-116.17c0-11.92-9.46-21.7-21.26-22.22Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M400.03,588.52c-12.26,0-22.24,9.98-22.24,22.24v116.17c0,12.26,9.98,22.24,22.24,22.24s22.24-9.98,22.24-22.24v-116.17c0-12.26-9.98-22.24-22.24-22.24Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M288.34,547.94c-12.26,0-22.24,9.98-22.24,22.24v116.17c0,12.26,9.98,22.24,22.24,22.24s22.24-9.98,22.24-22.24v-116.17c0-12.26-9.98-22.24-22.24-22.24Z"
		})
	]
});
export default SvgWithdrawal2;
